import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { BlockState } from "@redotech/redo-return-ui/flows/return-flow/block";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const BlockDetails = memo(function BlockDetails({
  state,
  setState,
}: StepTypeDetailsProps<BlockState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Message
      </Text>
      <RedoTextareaInputField
        placeholder="Enter message to display..."
        readOnly={!canEditReturnsSettings}
        setValue={(message) => setState((state) => ({ ...state, message }))}
        value={state.message}
      />
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Message to show to the customer. Can include HTML.
      </Text>
    </Flex>
  );
});
